module.exports = __webpack_public_path__ + "static/media/WI1@2x.e78aedbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI1@2x.png
// module id = 737
// module chunks = 0